import React from 'react';
import Button from '../ui/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/free-regular-svg-icons';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useCollections } from '../../context/CollectionsContext';
import ImageCardDetails from '../ImageCardDetails/ImageCardDetails';
import VideoCardDetails from '../VideoCard/VideoCardDetails';

const Collections = () => {
    const { collection } = useCollections();

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="text-center mb-8">
                <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 dark:text-white">
                    Your <span className="text-brand-500">collection</span>
                </h1>
                <p className="text-gray-500 dark:text-gray-400 mt-2">
                    Bookmarked on this device.
                </p>
            </div>

            {collection.length === 0 ? (
                <div className="flex flex-col items-center justify-center text-center mt-16 text-gray-400 dark:text-gray-500">
                    <FontAwesomeIcon icon={faBookmark} className="text-6xl mb-4" />
                    <h2 className="text-2xl font-bold">Your collection is empty</h2>
                    <p className="mt-1 mb-6">Tap the bookmark on any photo or video to add it here.</p>
                    <Button to="/photos" size="lg">
                        Browse photos <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                </div>
            ) : (
                <div className="grid sm:grid-cols-2 md:grid-cols-3 grid-cols-1 gap-6 animate-fade-in">
                    {collection.map((c) =>
                        c.kind === 'video' ? (
                            <VideoCardDetails key={`video-${c.id}`} video={c.item} />
                        ) : (
                            <ImageCardDetails key={`image-${c.id}`} image={c.item} />
                        )
                    )}
                </div>
            )}
        </div>
    );
};

export default Collections;
